import type { IntlShape } from "react-intl";
import { type AccessScope } from "@/graphql/generated/operations";

export function accessScopeLabel(scope: Pick<AccessScope, "kind" | "groupName">, intl: IntlShape): string {
  const kind = intl.formatMessage({ id: `admin.groups.scope.${scope.kind}` });
  return scope.groupName ? `${kind} · ${scope.groupName}` : kind;
}
